<template>
  <div
    v-if="environment !== 'prod'"
    :class="['env-badge', environment]"
  >
    <span class="kds-typography-title-xlarge">
      {{ environment.toUpperCase() }}
    </span>
  </div>
</template>

<script setup>
import env from '@shared/env.js'
import { computed } from 'vue'

const environment = computed(() => env.VITE_MODE || 'dev')
</script>

<style lang="scss" scoped>
.env-badge {
  background-color: $kds-color-background-yellow-accent;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.15);
  height: 150px;
  left: -75px;
  pointer-events: none;
  position: absolute;
  top: calc(env(safe-area-inset-top) - 75px);
  transform: rotate(-45deg) scale(0.3);
  width: 150px;
  z-index: 11;

  &.stage {
    background-color: $kds-color-background-green-accent;
  }

  span {
    bottom: 10px;
    position: absolute;
    text-align: center;
    width: 100%;
  }
}
</style>
